export const calculateHealthCareQuery = `mutation CalculateHealthCare(
    $policy: HealthCare_PolicyDetailsInput!
    $clientId: String!
    $sessionId: String!
) {
    calculateHealthCare(input: {
        input: {
            policyPolicyDetails: [$policy]
            commonTechnicals: {
                senderId: $clientId,
                sessionId: $sessionId
            }
        }
    }) {
        healthCare_PolicyDetailsStructure {
            policyPolicyDetails {
                expectedAcquisitionCommissionPartnerAmount
                contractNumber
                productCode
                productName
                porCompany
                companyNameDescription
                companyGroupName
                contractStatus
                underwritingYearPolicy
                declarationMethods {
                    method
                    isAllowed
                }
                policyDeliveryMethods {
                    method
                    isSupported
                }
                tags
                score
                scoreForPrice
                affiliateUrl
                externalSourceName
                paymentTermInMonths
                totalInstallmentAmount
                netPremiumInstallment
                grossPremiumInstallment
                blanketAgreementDiscountAmount
                premiumSurchargesInstallment
                orderFormId
                strictestLevelNewInsured
                zorgWebServiceProviderScore
                zorgWebFreeCareChoiceScore
                zorgWebFreeHospitalScore
                zorgWebFreeHospitalDescription
                zorgWebWeightedPurchaseScore
                zorgWebWeightedReviewValuation
                zorgWebWeightedServiceScore
                zorgWebWeightedRating
                zorgWebAddedValueScore
                zorgWebBehaviours {
                    code
                    score
                    title
                    components {
                        name
                         services {
                          description
                           extendedText
                        }
                        coverages {
                            costTypeId
                            costTypeUniqueTitle
                            expandedText
                            insuranceId
                            coverageType
                            contractCoverages {
                                summary
                                isContracted
                            }
                        }
                    }
                }
                coverageBasicHealths {
                    productCode
                    productDescription
                    totalInstallmentAmount
                    netPremiumInstallment
                    grossPremiumInstallment
                    blanketAgreementDiscountAmount
                    premiumSurchargesInstallment
                    deductibleAmount
                    deductibleDiscountAmount
                    zorgWebFreeChoice
                    rivmType
                    documents {
                        attachmentType
                        attachmentDescription
                        urlAttachment
                        fileName
                    }
                    acceptanceValues {
                        level
                        description
                        criteriaName
                        forWho
                        categoryName
                    }
                }
                coverageAdditionalHealths {
                    productCode
                    productDescription
                    totalInstallmentAmount
                    netPremiumInstallment
                    grossPremiumInstallment
                    blanketAgreementDiscountAmount
                    premiumSurchargesInstallment
                    deductibleAmount
                    deductibleDiscountAmount
                    zorgWebFreeChoice
                    rivmType
                    documents {
                        attachmentType
                        attachmentDescription
                        urlAttachment
                        fileName
                    }
                    acceptanceValues {
                        level
                        description
                        criteriaName
                        forWho
                        categoryName
                    }
                }
                coverageDentistHealths {
                    productCode
                    productDescription
                    totalInstallmentAmount
                    netPremiumInstallment
                    grossPremiumInstallment
                    blanketAgreementDiscountAmount
                    premiumSurchargesInstallment
                    deductibleAmount
                    deductibleDiscountAmount
                    zorgWebFreeChoice
                    rivmType
                    documents {
                        attachmentType
                        attachmentDescription
                        urlAttachment
                        fileName
                    }
                    acceptanceValues {
                        level
                        description
                        criteriaName
                        forWho
                        categoryName
                    }
                }
                partyPolicyHolders {
                    birthDate
                    genderOrLegalPersonType
                    totalInstallmentAmount
                    netPremiumInstallment
                    grossPremiumInstallment
                    deductibleDiscountAmount
                    blanketAgreementDiscountAmount
                    premiumSurchargesInstallment
                    deductibleAmount
                    coverageBasicHealths {
                        totalInstallmentAmount
                        netPremiumInstallment
                        grossPremiumInstallment
                        deductibleDiscountAmount
                        blanketAgreementDiscountAmount
                        premiumSurchargesInstallment
                        deductibleAmount
                    }
                    coverageAdditionalHealths {
                        totalInstallmentAmount
                        netPremiumInstallment
                        grossPremiumInstallment
                        deductibleDiscountAmount
                        blanketAgreementDiscountAmount
                        premiumSurchargesInstallment
                        deductibleAmount
                    }
                    coverageDentistHealths {
                        totalInstallmentAmount
                        netPremiumInstallment
                        grossPremiumInstallment
                        deductibleDiscountAmount
                        blanketAgreementDiscountAmount
                        premiumSurchargesInstallment
                        deductibleAmount
                    }
                    partyPartners {
                        birthDate
                        genderOrLegalPersonType
                        totalInstallmentAmount
                        netPremiumInstallment
                        grossPremiumInstallment
                        deductibleDiscountAmount
                        blanketAgreementDiscountAmount
                        premiumSurchargesInstallment
                        deductibleAmount
                        coverageBasicHealths {
                            totalInstallmentAmount
                            netPremiumInstallment
                            grossPremiumInstallment
                            deductibleDiscountAmount
                            blanketAgreementDiscountAmount
                            premiumSurchargesInstallment
                            deductibleAmount
                        }
                        coverageAdditionalHealths {
                            totalInstallmentAmount
                            netPremiumInstallment
                            grossPremiumInstallment
                            deductibleDiscountAmount
                            blanketAgreementDiscountAmount
                            premiumSurchargesInstallment
                            deductibleAmount
                        }
                        coverageDentistHealths {
                            totalInstallmentAmount
                            netPremiumInstallment
                            grossPremiumInstallment
                            deductibleDiscountAmount
                            blanketAgreementDiscountAmount
                            premiumSurchargesInstallment
                            deductibleAmount
                        }
                    }
                    partyChildren {
                        birthDate
                        genderOrLegalPersonType
                        totalInstallmentAmount
                        netPremiumInstallment
                        grossPremiumInstallment
                        deductibleDiscountAmount
                        blanketAgreementDiscountAmount
                        premiumSurchargesInstallment
                        deductibleAmount
                        coverageBasicHealths {
                            totalInstallmentAmount
                            netPremiumInstallment
                            grossPremiumInstallment
                            deductibleDiscountAmount
                            blanketAgreementDiscountAmount
                            premiumSurchargesInstallment
                            deductibleAmount
                        }
                        coverageAdditionalHealths {
                            totalInstallmentAmount
                            netPremiumInstallment
                            grossPremiumInstallment
                            deductibleDiscountAmount
                            blanketAgreementDiscountAmount
                            premiumSurchargesInstallment
                            deductibleAmount
                        }
                        coverageDentistHealths {
                            totalInstallmentAmount
                            netPremiumInstallment
                            grossPremiumInstallment
                            deductibleDiscountAmount
                            blanketAgreementDiscountAmount
                            premiumSurchargesInstallment
                            deductibleAmount
                        }
                    }
                }
                customProperties {
                    supplierKrn
                }
                underwritingCompanySpecifics {
                    underwritingResult
                }
            }
            processStatusNotifications {
                messageCategoryDescription
                codedMessage
                healthDeclarationExplanation
            }
            commonTechnicals {
                transactionReference
                accessCode
            }
        }
        errors {
            ... on HealthCare_InvalidClientError {
                type
                message
                code
            }
            ... on HealthCare_InvalidValueError {
                type
                message
                path
                value
            }
            ... on HealthCare_MissingRecordsError {
                type
                message
                path
                minimumNumberOfElements
            }
            ... on HealthCare_MissingSingleRecordError {
                type
                message
                path
            }
            ... on HealthCare_MissingValueError {
                type
                message
                path
            }
            ... on HealthCare_IGraphQlErrorBase {
                type
                message
            }
        }
    }
}`;
